import { Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: "[containerContent]",
  standalone: false
})
export class ContainerContentDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
